import { SerialType } from "./SerialType";
import { WithPagination } from "./WithPagination";

export * from "./utils";

export * from "./SerialType";
export * from "./UnparsedQueryParams";
export * from "./WithPagination";
export * from "./optional";
export * from "./ValidateArraySumEquals";

/** Given an object of type T that extends type U, return
 * a type that includes ony properties in T not in U
 */
export type OmitFrom<T extends U, U extends object> = Omit<T, keyof U>;

/** Removes skip and take parameters from
 *  from a dto
 */
export type WithoutPagination<T extends WithPagination> = OmitFrom<T, WithPagination>;

/** With both pagination and query parameters
 */
export interface WithPaginationAndQuery extends WithPagination {
  query?: string;
}

/**
 * Serialized and with query and pagination properties removed
 */
export type SerializedQueryOpts<T extends WithPagination> = SerialType<
OmitFrom<T, WithPaginationAndQuery>
>;

export type WithPage<T extends object = Record<string, never>> = T & {
  page?: number;
};

export type TStringOrNumber = string | number;
export type TNullableStringOrNumber = TStringOrNumber | null;
